var map = {
	"./1m.svg": 191,
	"./1w.svg": 192,
	"./2m.svg": 193,
	"./2w.svg": 194,
	"./3m.svg": 195,
	"./3w.svg": 196,
	"./4w.svg": 197,
	"./5w.svg": 198,
	"./check.svg": 199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;